export enum Mutations {
    SET_CURRENT_COMPONENT = 'SET_CURRENT_COMPONENT',
    SET_MESSAGE = 'SET_MESSAGE',
    SET_FEEDBACK_TYPE = 'SET_FEEDBACK_TYPE',
    SET_CURRENT_PAGE = 'SET_CURRENT_PAGE',
    SET_APIKEY = 'SET_APIKEY',
    SET_FINGERPRINT = 'SET_FINGERPRINT',
    RESET_STORE = 'RESET_STORE',
}
